import { Context, Middleware } from '../types';

export async function invokeMiddlewares<T>(
  middlewares: Middleware<T>[],
  input: T,
  context: Context
): Promise<T> {
  return await middlewares.reduce<Promise<T>>(
    async (prevPromise, middleware) =>
      await middleware(await prevPromise, context),
    Promise.resolve(input)
  );
}
